import { SchemaType } from '../type';
export const schema = {
    id: 'workflow',
    name: get => `审批流（${get('name')}）`,
    type: SchemaType.Indivisible,
};
